enum RequestAbortSignal {
  Segments = 'SEGMENTS',
}

export default RequestAbortSignal;
